<template>
  <a :href="href" :aria-label="ariaLinkDescription" @focus="isHover = true" @blur="isHover = false">
    <div
      class="marketing-product-tile product-tile ragnarok"
      @mouseenter="isHover = true"
      @mouseleave="isHover = false"
    >
      <div
        class="marketing-product-tile--background-image"
        :style="backgroundImage"
      ></div>

      <div class="product custom is-flex-bottom has-dark-background">
        <slide-y-up-transition group>
          <div v-for="line in lines" :key="line" v-html="line"></div>
        </slide-y-up-transition>
      </div>
    </div>
  </a>
</template>

<style lang="sass" scoped>
.marketing-product-tile {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    color: #fcfcfc;
    background-color: #000000;

    .marketing-product-tile--background-image {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background-size: cover;
      background-position: center;
    }

    .marketing-product-tile--description-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      padding: 15px 20px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }

    &:hover {
      .marketing-product-tile--background-image {
        filter: blur(13px);
        top: -2.5%;
        left: -2.5%;
        width: 105%;
        height: 105%;
      }
    }
}

.has-dark-background {
    background-color: rgba(25, 25, 25, 0.7);
}

.has-text-white {
  color: #fcfcfc;
}
</style>

<script>
import {
  SlideYUpTransition,
  SlideYDownTransition,
  FadeTransition,
} from "vue2-transitions";

export default {
  name: "MarketingProductTile",

  components: {
    SlideYUpTransition,
    SlideYDownTransition,
    FadeTransition,
  },

  data: () => ({
    isHover: false,
  }),

  props: {
    title: { type: String, default: null },
    desc: { type: String, default: null },
    iconClass: { type: String, default: null },
    link: { type: String, default: null },
    href: { type: String, default: null },
    background: { type: String, default: null },
  },

  computed: {
    ariaLinkDescription() {
      const description = []

      if (this.title) description.push(this.title);
      if (this.desc) description.push(this.desc);
      if (this.link) description.push("Click to " + this.link);

      return description.join(". ");
    },

    backgroundImage() {
      return this.background ? { backgroundImage: `url("${this.$cdn(this.background)}")` } : {};
    },

    lines() {
      return [
        !!this.iconClass ? `<i class="is-size-2 mb-5 ${this.iconClass}"></i>` : null,
        !!this.title
          ? `<div class="title is-3 mb-3 has-text-white">${this.title}</div>`
          : null,
        !!this.desc ? `<p>${this.desc}</p>` : null,
        !!this.link && this.isHover
          ? `<p style="text-decoration: underline !important">${this.link}</p>`
          : null,
      ].filter((it) => it !== null);
    },
  },
};
</script>
